<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Manufacturer"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewManufacturer"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="manufacturers"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="id"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Manfacturers"
    >
      <template #header>
        <div class="table-header">Related Manufacturers.</div>
      </template>

      <template #empty> No Related Manufacturers found! </template>
      <template #loading>
        Loading Related Manufacturers. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column
        field="manufacturerCode"
        header="Manufacturer Code"
        :sortable="true"
      >
        <template #body="slotProps">
          {{
            slotProps.data.manufacturerCode
              ? slotProps.data.manufacturerCode
              : ""
          }}
        </template>
      </Column>
      <Column
        field="manufacturerName"
        header="Manufacturer Name"
        :sortable="true"
      >
        <template #body="slotProps">
          {{
            slotProps.data.manufacturerName
              ? slotProps.data.manufacturerName
              : ""
          }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editManufacturer(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="manufacturerForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Manufacturer"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteHeader">Manufacturer Code:</label>
          <InputText
            id="manufacturerCode"
            v-model.trim="manufacturer.manufacturerCode"
            required="true"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="manufacturerName">Manufacturer Name:</label>
          <InputText
            id="manufacturerName"
            v-model.trim="manufacturer.manufacturerName"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="active">Active:</label>
          <SelectButton
            v-model="manufacturer.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="manufacturerForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Manufacturer?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteManufacturer"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  quotationService: null,
  data: () => ({
    manufacturerForm: false,
    displayConfirmation: false,
    filters: {},
    manufacturers: null,
    manufacturer: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    requesting: false
  }),
  computed: {
    loading() {
      if (this.manufacturers && this.manufacturers[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.quotationService = new QuotationService();
  },
  mounted() {
    this.getAllManufacturers();
  },
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    async getAllManufacturers() {
      this.requesting = true;
      this.manufacturers = await this.quotationService.getAllManufacturersByHard();
      this.requesting = false;
    },
    async getAllActiveManufacturersByHard() {
      await this.quotationService.getAllActiveManufacturersByHard();
    },
    openNewManufacturer() {
      this.manufacturer = {};
      this.manufacturerForm = true;
    },
    openConfirmation(data) {
      this.manufacturer = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editManufacturer(data) {
      this.manufacturer = data;
      this.manufacturerForm = true;
    },
    async deleteManufacturer() {
      this.closeConfirmation();
      await this.quotationService.deleteManufacturer(this.manufacturer.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Manufacturer removed",
        life: 5000
      });
      this.getAllManufacturers();
      this.getAllActiveManufacturersByHard();
    },
    save() {
      if (!this.manufacturer.id) {
        this.quotationService
          .postManufacturer(this.manufacturer)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Manufacturer added",
              life: 5000
            });
            this.getAllManufacturers();
            this.getAllActiveManufacturersByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving Manufacturer",
              life: 5000
            });
          });
      } else {
        this.quotationService
          .putManufacturer(this.manufacturer, this.manufacturer.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Manufacturer updated",
              life: 5000
            });
            this.getAllManufacturers();
            this.getAllActiveManufacturersByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating manufacturer",
              life: 5000
            });
          });
      }
      this.manufacturerForm = false;
    }
  }
};
</script>
